import type * as Types from '@__graphql__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrderHistoryProduct_Magento2_BundleOrderItem_Fragment = { returnStatus?: string | null, id: string, productName?: string | null, status?: string | null, productSku: string, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null };

export type OrderHistoryProduct_Magento2_DownloadableOrderItem_Fragment = { returnStatus?: string | null, id: string, productName?: string | null, status?: string | null, productSku: string, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null };

export type OrderHistoryProduct_Magento2_GiftCardOrderItem_Fragment = { returnStatus?: string | null, id: string, productName?: string | null, status?: string | null, productSku: string, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null };

export type OrderHistoryProduct_Magento2_OrderItem_Fragment = { returnStatus?: string | null, id: string, productName?: string | null, status?: string | null, productSku: string, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null };

export type OrderHistoryProductFragment = OrderHistoryProduct_Magento2_BundleOrderItem_Fragment | OrderHistoryProduct_Magento2_DownloadableOrderItem_Fragment | OrderHistoryProduct_Magento2_GiftCardOrderItem_Fragment | OrderHistoryProduct_Magento2_OrderItem_Fragment;

export type OrderHistoryOrderFragment = { id: string, number: string, orderDate: string, status: string, statusCode: string, total?: { grandTotal: { value?: number | null, currency?: Types.Magento2_CurrencyEnum | null } } | null, items?: Array<{ returnStatus?: string | null, id: string, productName?: string | null, status?: string | null, productSku: string, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null } | { returnStatus?: string | null, id: string, productName?: string | null, status?: string | null, productSku: string, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null } | { returnStatus?: string | null, id: string, productName?: string | null, status?: string | null, productSku: string, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null } | { returnStatus?: string | null, id: string, productName?: string | null, status?: string | null, productSku: string, eligibleForReturn?: boolean | null, quantityCanceled?: number | null, quantityInvoiced?: number | null, quantityOrdered?: number | null, quantityRefunded?: number | null, quantityReturned?: number | null } | null> | null };

export type OrderHistoryOrdersFragment = { totalCount?: number | null, pageInfo?: { currentPage?: number | null } | null, items: Array<OrderHistoryOrderFragment | null> };

export type OrderHistoryQueryVariables = Types.Exact<{
  currentPage?: Types.InputMaybe<Types.Scalars['Int']>;
  orderStatuses?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>>;
}>;


export type OrderHistoryQuery = { magento2?: { customer?: { email?: string | null, nativeId?: string | null, globalOrders?: OrderHistoryOrdersFragment | null } | null } | null };

export const OrderHistoryProductFragmentDoc = gql`
    fragment OrderHistoryProduct on Magento2_OrderItemInterface {
  returnStatus
  id
  productName
  status
  productSku
  eligibleForReturn
  quantityCanceled
  quantityInvoiced
  quantityOrdered
  quantityRefunded
  quantityReturned
}
    `;
export const OrderHistoryOrderFragmentDoc = gql`
    fragment OrderHistoryOrder on Magento2_GlobalCustomerOrder {
  id
  number
  orderDate
  total {
    grandTotal {
      value
      currency
    }
  }
  status
  statusCode
  items {
    returnStatus
    id
    productName
    status
    productSku
    eligibleForReturn
    quantityCanceled
    quantityInvoiced
    quantityOrdered
    quantityRefunded
    quantityReturned
  }
}
    `;
export const OrderHistoryOrdersFragmentDoc = gql`
    fragment OrderHistoryOrders on Magento2_GlobalCustomerOrders {
  totalCount
  pageInfo {
    currentPage
  }
  items {
    ...OrderHistoryOrder
  }
}
    ${OrderHistoryOrderFragmentDoc}`;
export const OrderHistoryDocument = gql`
    query OrderHistory($currentPage: Int, $orderStatuses: [String]) {
  magento2 {
    customer {
      email
      nativeId
      globalOrders(
        pageSize: 30
        currentPage: $currentPage
        filter: {global_order_status_code: {in: $orderStatuses}}
      ) {
        ...OrderHistoryOrders
      }
    }
  }
}
    ${OrderHistoryOrdersFragmentDoc}`;

/**
 * __useOrderHistoryQuery__
 *
 * To run a query within a React component, call `useOrderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderHistoryQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      orderStatuses: // value for 'orderStatuses'
 *   },
 * });
 */
export function useOrderHistoryQuery(baseOptions?: Apollo.QueryHookOptions<OrderHistoryQuery, OrderHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderHistoryQuery, OrderHistoryQueryVariables>(OrderHistoryDocument, options);
      }
export function useOrderHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderHistoryQuery, OrderHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderHistoryQuery, OrderHistoryQueryVariables>(OrderHistoryDocument, options);
        }
export type OrderHistoryQueryHookResult = ReturnType<typeof useOrderHistoryQuery>;
export type OrderHistoryLazyQueryHookResult = ReturnType<typeof useOrderHistoryLazyQuery>;
export type OrderHistoryQueryResult = Apollo.QueryResult<OrderHistoryQuery, OrderHistoryQueryVariables>;